import React from "react";
import { useTranslation } from "react-i18next";

import { languageName } from "astrid-helpers/src/languages";

import Flex from "../../../components/Flex/Flex";
import CoverImageStack from "../../ui/components/CoverImage/CoverImageStack";
import themeColors from "../../ui/constants/themeColors";
import { timestampColumn } from "../../ui/utils/columns";

export default function useWorksTableColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "name",
			collapsing: true,
			Header: t("title", "Title"),
			Cell: ({ value, row }) => {
				return (
					<Flex justifyContent="flex-start">
						<Flex style={{ marginRight: "1.1em", height: 45, width: 45 }}>
							<CoverImageStack thumb rounded data={row} size={45} style={{ margin: "0 auto" }} />
						</Flex>

						<div>
							{value}
							<div style={{ color: themeColors.GREY }}>{row.subtitle}</div>
						</div>
					</Flex>
				);
			},
		},
		{
			id: "authors",
			Header: t("authors", "Authors"),
			accessor: ({ authors }) => authors?.join(", "),
		},
		{
			id: "translators",
			Header: t("translators", "Translators"),
			accessor: ({ translators }) => translators?.join(", "),
		},
		{
			id: "serie.name",
			disableSortBy: true,
			Header: t("series", "Series"),
		},
		{
			id: "imprint.name",
			Header: t("imprint", "Imprint"),
			collapsing: true,
		},
		{
			id: "language",
			Header: t("language", "Language"),
			collapsing: true,
			accessor: ({ language }) => languageName(language),
		},
		timestampColumn({ id: "updated", Header: t("updated", "Updated"), time: false }),
		timestampColumn({ id: "created", Header: t("created", "Created"), time: false }),
	];
}
